import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBriefcase, faUsers, faHardHat, faIdCard, faClock, faBook, 
  faClipboardList, faMoneyCheckAlt, faMoneyBillWave, faHandsHelping, 
  faImage, faEye, faStar, faQrcode, faUser, faLockOpen,
  faSadCry,
  faWallet,
  faSearch,
  faClockRotateLeft,
  faClipboardQuestion
} from '@fortawesome/free-solid-svg-icons';
import './JobsWorks.css';
// import educationjobsimage from '../../assets/gdashboard/EducationJobs.png';
import Tooltip from '../../components/utils/Tooltip';

function EducationJobsHome() {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [category, setCategory] = useState("");
  const [subject, setSubject] = useState("Maths");

  const [searchCity, setSearchCity] = useState("Mumbai");
  const [customCity, setCustomCity] = useState("");
  const [customSubject, setCustomSubject] = useState("");
  const [jobsData, setJobsData] = useState([]);
  const [isInstant, setIsInstant] = useState(false);
  const [error, setError] = useState(null);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [applyRemarks, setApplyRemarks] = useState("");
  const [applied, setApplied] = useState(false);

  const handleSearch = () => {
    // console.log("Search Query:", searchKeyword);
    // console.log("Category:", category);
    // console.log("City:", city);
    setIsInstant(false);

    fetchJobs(false);
    // API Call for database fetching logic here
  };

  const handleInstant = () => {
    setIsInstant(true);
    fetchJobs(true);
    // API Call for database fetching logic here
  };

  useEffect(() => {
    
  }, [isInstant]);

  const fetchJobs = useCallback((instant) => {
    const config = {
      url: "/educationjobs/jobs",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        userId: userId, 
        searchKeyword: searchKeyword, 
        category: category, 
        subject: subject,
        customSubject: customSubject,
        searchCity: searchCity, 
        customCity: customCity,
        isInstant: instant
      },
    };
    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        if (response?.jobsData) {
          if (Array.isArray(response.jobsData)) {
            setJobsData(response.jobsData);
          } else {
            setJobsData([response.jobsData]);
          }
        } else {
          console.error("Invalid jobs data format: ", response.jobsData);
          setJobsData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching Job data:", error);
      });
  }, [
    authState.token,
    searchKeyword,
    category,
    subject,
    customSubject,
    searchCity,
    customCity,
    fetchData,
  ]);

  const handleView = (jobId) => {
    setSelectedJobId(prevId => (prevId === jobId ? null : jobId));
  };

  const handleJobShare = (jobId) => {
    setSelectedJobId(jobId);
  };

  const handleJobSave = (jobId) => {
    setSelectedJobId(jobId);
  };

  // const handleJobApply(jobid, jobcode, postedby){
  //   setSelectedJobId(jobid);
  //   applyJob(jobcode, jobid, postedby);
  // };

  const handleJobApply = (jobcode, jobid, postedby) => {
    const config = {
      url: "/educationjobsapply/apply",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        userId,
        userCode: authState.user.think5whyscode,
        jobCode: jobcode,
        jobId: jobid,
        postedBy: postedby,
        applyDate: new Date(),
        applyRemarks,
        isWithdraw: false,
        reviewerId: null,
        reviewerCode: '',
        reviewDate: null,
        reviewRemarks: '',
        reviewStatus: '',
        isHide: false,
      },
    };
  
    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        setApplied(true);
      })
      .catch((error) => {
        console.error("Error applying this job:", error);
      });
  }; 
  // , [authState.token, authState.user.think5whyscode, userId, applyRemarks, fetchData]);

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const formatDate = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // const sortedJobs = [...jobs].sort((a, b) => new Date(b.applyFromDate) - new Date(a.applyFromDate));

  const JobList = ({ jobs, category, isInstant, searchKeyword, searchCity, customCity }) => (
    <>
      <p className="text-yellow-300">
        {jobs.length} {category} {isInstant ? "Instant" : "Regular"} Jobs Found for {searchKeyword} in {searchCity} {customCity}
      </p>
      {jobs.map((job, index) => (
        <JobCard
          key={job._id}
          job={job}
          index={index}
          selectedJobId={selectedJobId}
          onView={handleView}
          onShare={handleJobShare}
          onSave={handleJobSave}
          onApply={handleJobApply(job._id, job.jobCode, job.employerName)}
        />
      ))}
    </>
  );
  
  const JobCard = ({ job, index, selectedJobId, onView, onShare, onSave, onApply }) => (
    <div className="bg-white my-1 p-1 text-gray-600 rounded-md shadow-md text-sm">
      <div className="flex">
        <span className="font-medium">
          {index + 1}. {job.jobTitle}, ({formatDateTime(job.datePosted)})
        </span>
        <Tooltip text="View details" position="top">
          <span className="ml-auto mr-4 text-education-500 cursor-pointer" onClick={() => onView(job._id)}>
            <i className="fa-solid fa-eye"></i>
          </span>
        </Tooltip>
      </div>
      {selectedJobId === job._id && (
        <JobDetails job={job} onShare={onShare} onSave={onSave} onApply={onApply} />
      )}
    </div>
  );
  
  const JobDetails = ({ job, onShare, onSave, onApply }) => (
    <div className="bg-gray-200 text-black">
      <div className="bg-education-700 text-white justify-center text-m mt-2 mb-2">
        <h2 className="text-white">
          <strong>Job Details</strong>
        </h2>
      </div>
      <p><strong>Job Code:</strong> {job.jobCode}</p>
      <p><strong>Job Title:</strong> {job.jobTitle}</p>
      <p><strong>Location:</strong> {job.jobLocation}</p>
      <p><strong>Category:</strong> {job.jobCategory}</p>
      <p><strong>Description:</strong> {job.jobDescription}</p>
      <p><strong>Salary Details:</strong> {job.salaryDetails}</p>
      <p><strong>Remarks:</strong> {job.splRemarks}</p>
      <p><strong>Employer:</strong> {job.employerName}</p>
      <p>{job.employerDetails}</p>
      <p>{job.employerAddress}</p>
      <p><strong>Department:</strong> {job.department}</p>
      <p><strong>Application Period:</strong> {formatDate(job.applyFromDate)}{' to '}{formatDate(job.applyToDate)}</p>
      <p><strong>Date Posted:</strong> {formatDate(job.datePosted)}</p>
      <div className="flex mt-2">
        <Tooltip text="Share" position="top">
          <span className="text-green-500 cursor-pointer mr-4" onClick={() => onShare(job._id)}>
            <i className="fa-solid fa-share"></i>
          </span>
        </Tooltip>
        <Tooltip text="Shortlist" position="top">
          <span className="text-education-500 cursor-pointer mr-4" onClick={() => onSave(job._id)}>
            <i className="fa-solid fa-save"></i>
          </span>
        </Tooltip>
        <Tooltip text="Apply" position="top">
          <span className="text-orange-500 cursor-pointer mr-4" onClick={() => onApply(job._id)}>
            <i className="fa-solid fa-print"></i>
          </span>
        </Tooltip>
      </div>
    </div>
  );
  
  const NoJobsMessage = ({ isInstant, category, searchKeyword, searchCity, customCity }) => (
    <p className="text-yellow-300">
      No {isInstant ? "Instant" : "Regular"} {category} Jobs Found for {searchKeyword} in {searchCity} {customCity}
    </p>
  );
  
  return (
    <MainLayout>
      <div className="min-h-full py-8 bg-gradient-to-r from-education-400 via-education-500 to-education-600 mt-12">
        <h2 className='text-3xl font-bold text-white text-center mb-6'>Education Sector Jobs</h2>
        <div className="min-h-[100vh] px-4">
          <div className="flex flex-col items-center mb-8 mt-16 border-2 border-yellow-200 rounded-md p-6">
            <div className="flex flex-row justify-center md:flex-row md:space-x-4 space-y-4 md:space-y-0 w-full">
              <label>
                <FontAwesomeIcon icon={faSearch} className='text-yellow-200 text-lg ml-4'/>
              </label>
              <input
                type="text"
                placeholder="Enter search keywords eg Economics, Biology etc"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-education-500"
              />
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-education-500"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
              >
                <option value="Primary Teacher">Primary Teacher</option>
                <option value="Secondary Teacher">Secondary Teacher</option>
                <option value="Junior College Teacher">Junior College Teacher</option>
                <option value="Higher Education Teacher">Higher Education Teacher</option>
                <option value="Professional Tutors">Professional Tutors</option>
                <option value="Coaching Teacher">Coaching Teacher</option>
                <option value="Tuition Teacher">Tuition Teacher</option>
                <option value="Contract Teacher">Contract Teacher</option>
                <option value="Visiting Teacher">Visiting Teacher</option>
                <option value="B.Ed. Teacher">B.Ed. Teacher</option>
                <option value="M.Ed. Teacher">M.Ed. Teacher</option>
                <option value="Other Teacher">Other Teacher</option>
                <option value="Doctorate Teacher">Doctorate Teacher</option>
                <option value="Administrator">Administrator</option>
                <option value="Office Assistant">Office Assistant</option>
                <option value="Other Jobs">Other Jobs</option>
              </select>
              <select
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-education-500"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
              >
                <option value="Science">Science</option>
                <option value="Arts">Arts</option>
                <option value="Commerce">Commerce</option>
                <option value="Maths">Maths</option>
                <option value="Management">Management</option>
                <option value="Fine Art">Fine Art</option>
                <option value="Sports">Sports</option>
                <option value="Technical">Technical</option>
                <option value="Medcial">Medcial</option>
                <option value="IT">IT</option>
                <option value="">Others</option>
              </select>
              <select
                value={searchCity}
                onChange={(e) => setSearchCity(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-3 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-education-500 text-base"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
                >
                <option value="Mumbai">Mumbai</option>
                <option value="Delhi">Delhi</option>
                <option value="Bangalore">Bangalore</option>
                <option value="Ahmedabad">Ahmedabad</option>
                <option value="Hyderabad">Hyderabad</option>
                <option value="Chennai">Chennai</option>
                <option value="Pune">Pune</option>
                <option value="">Other Location</option>
              </select>
            </div>
            { subject === "" && (
              <div className='mt-4'>
                <input
                  type="text"
                  placeholder="Enter Subject Name"
                  value={customSubject}
                  onChange={(e) => setCustomSubject(e.target.value)}
                  className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-education-500"
                  style= {{width: "300px"}}
                />
              </div>
            )}
            { searchCity === "" && (
              <div className='mt-4'>
                <input
                  type="text"
                  placeholder="Enter location"
                  value={customCity}
                  onChange={(e) => setCustomCity(e.target.value)}
                  className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-education-500"
                  style= {{width: "300px"}}
                />
              </div>
            )}
            <div className='flex flex-row mt-4'>
              <button
                onClick={handleSearch}
                className="mr-4 bg-education-800 text-white px-6 py-2 w-40 hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-800"
              >
                Search
              </button>
              <button
                onClick={handleInstant}
                className="bg-education-800 text-white px-6 py-2 w-40 hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-800"
              >
                Instant
              </button>
            </div>
            {/* {jobsData.length} */}
            {jobsData.length > 0 ? (
              <JobList
                jobs={jobsData}
                category={category}
                subject={subject}
                customSubject={customSubject}
                isInstant={isInstant}
                searchKeyword={searchKeyword}
                searchCity={searchCity}
                customCity={customCity}
              />
            ) : (
              <NoJobsMessage
                isInstant={isInstant}
                category={category}
                subject={subject}
                customSubject={customSubject}
                searchKeyword={searchKeyword}
                searchCity={searchCity}
                customCity={customCity}
              />
            )}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-250">
            <CardLink to="/educationjobs-iamavailable" icon={faHandsHelping} text="I am Available" />
            <CardLink to="/myprofile-educationprofile" icon={faUser} text="My Teaching Profile" />
            <CardLink to="/contact-genious-myqr" icon={faQrcode} text="My QR Code" />
            <CardLink to="/contact-genious/education" icon={faIdCard} text="My Secure Teacher Card" />
            <CardLink to={`/pub/education/${userCode}`} icon={faLockOpen} text="My Public Teacher Card" />
            <CardLink to="" icon={faClock} text="My Attendance" />
            <CardNoLink to="" icon={faBook} text="My Work Diary" />
            <CardNoLink to="" icon={faUser} text="Write My Bio-Data" />
            <CardLink to="/attendance-capture-qr" icon={faImage} text="Attendance Locations" />
            <CardNoLink to="" icon={faClipboardQuestion} text="My Shortlisted Jobs" />
            <CardNoLink to="" icon={faClockRotateLeft} text="Jobs I Applied" />
            <CardNoLink to="" icon={faQrcode} text="My Search Log" />
            <CardNoLink to="" icon={faEye} text="Who Searched Me" />
            <CardNoLink to="" icon={faWallet} text="Price List" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default EducationJobsHome;


